"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMargin = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledMargin = styled_components_1.default.div `
  margin: ${({ top, right, bottom, left }) => [top || 0, right || 0, bottom || 0, left || 0].join(' ')};
`;
